import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";
// import { useLocation } from "react-router-dom";

const useLogin = () => {
  // let history = useHistory();
  // let location = useLocation();
  // let auth = useAuth();

  // let { from } = location.state || { from: { pathname: "/" } };
  // let login = () => {
  //   auth.signin(() => {
  //     history.replace(from);
  //   });
  // };

  const { locale } = useBetween(useSelector((state) => state.useSharedState));
  const [logInUpPhone, setLogInUpPhone] = useState("");
  const [logInUpPass, setLogInUpPass] = useState("");
  const [CorrectPassword, setCorrectPassword] = useState("123");
  const [passwordType, setPasswordType] = useState("password");
  const [eye, setEye] = useState(true);

  // Error Messages
  const [PhoneNumberError, setPhoneNumberError] =
    useState("phone-number-error");
  const [PasswordError, setPasswordError] = useState("password-error");

  // Regular Expressions
  const regExpPhoneNumber = new RegExp(
    "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$"
  ); //+919367788755

  const Eye = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      setEye(false);
    } else {
      setPasswordType("password");
      setEye(true);
    }
  };

  const onChangeInput = (event, inputID) => {
    document.getElementById(inputID).classList.remove("is-invalid");
    if (inputID === "LoginPhone") {
      setLogInUpPhone(event.target.value);
    } else if (inputID === "LoginPassword") {
      setLogInUpPass(event.target.value);
    }
  };

  const checkInput = (e) => {
    e.preventDefault();
    if (logInUpPhone === "" || logInUpPass === "") {
      if (logInUpPhone === "")
        document.getElementById("LoginPhone").classList.add("is-invalid");
      if (logInUpPass === "")
        document.getElementById("LoginPassword").classList.add("is-invalid");
    } else if (
      !regExpPhoneNumber.test(logInUpPhone) ||
      logInUpPass !== CorrectPassword
    ) {
      if (!regExpPhoneNumber.test(logInUpPhone)) {
        setPhoneNumberError("phone-number-input-error");
        document.getElementById("LoginPhone").classList.add("is-invalid");
      }
      if (logInUpPass !== CorrectPassword) {
        setPasswordError("password-input-error");
        document.getElementById("LoginPassword").classList.add("is-invalid");
      }
    } else {
      document.getElementById("LogIntoHome").click();
    }
  };
  const toSignUp = () => {
    document.querySelector(".Signup").classList.toggle("current-section-start");
    document.querySelector(".Login").classList.remove("current-section-start");
    document
      .querySelector(".copy-rights-section")
      .classList.remove("current-section-start");
  };
  const backToStartUp = (e) => {
    e.preventDefault();
    document
      .querySelector(".Startup-form")
      .classList.toggle("current-section-start");
    document
      .querySelector(".copy-rights-section")
      .classList.toggle("current-section-start");
    document.querySelector(".Login").classList.remove("current-section-start");
  };

  return {
    locale,
    eye,
    passwordType,
    PhoneNumberError,
    PasswordError,
    Eye,
    onChangeInput,
    checkInput,
    toSignUp,
    backToStartUp,
  };
};

export default useLogin;
